// ui-kit/icons.mjs: React-vrije glyphpaden die zowel de primitieven als
// servercode (lib/banner-templates.mjs via lib/partnerbook-icons.mjs) tekenen.

// Het takglyph van ELK proces (eigenaarsbesluit 4 oktober 2026): EntityIcon entity="process", RailIcon
// 'processen', de lege processtaat, de KPI-kolom Processen en de banner. Vier
// paden in 24x24, lijn, currentColor. Staat hier EEN keer; lib/partnerbook-icons.mjs
// en components/HomeV2/lib.js heruitvoeren hem. Ratchet: lib/design-procesglyph.test.mjs.
export const BRANCH_PATHS = ['M6 3V15', 'M15 6a3 3 0 1 0 6 0a3 3 0 1 0-6 0', 'M3 18a3 3 0 1 0 6 0a3 3 0 1 0-6 0', 'M18 9a9 9 0 0 1-9 9'];
